import { SvgIconProps, SvgIcon, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

const StyledSvgIcon: OverridableComponent<SvgIconTypeMap<{component: any}, "svg">> = (props: SvgIconProps ) => {
  return (
    <SvgIcon viewBox="0 0 48 48" {...props} />
  )
}

export default StyledSvgIcon